import { get, readable, writable } from "svelte/store";
import { State } from "./State";
export class Question {
    constructor(form, section, id, name, description, status, useAnswerInFileName, position, width, type, forced, date_created, date_updated, date_disabled, sections, options) {
        this.form = form;
        this.section = section;
        this.id = id;
        this.type = type;
        this.options = options;
        this.sectionsWritable = writable([]);
        this.sectionsReadable = readable([], set => this.sectionsWritable.subscribe(set));
        this.name = new State(name);
        this.description = new State(description);
        this.status = new State(status);
        this.useAnswerInFileName = new State(useAnswerInFileName);
        this.position = new State(position);
        this.width = new State(width);
        this.forced = new State(forced);
        this.date_created = new State(date_created);
        this.date_updated = new State(date_updated);
        this.date_disabled = new State(date_disabled);
        for (const section of sections) {
            this.addSection(section);
        }
    }
    get sections() {
        return [...get(this.sectionsWritable)];
    }
    addSection(section) {
        if (this.hasSection(section.id)) {
            return;
        }
        const sections = [...this.sections, section];
        this.updateSectionsPositions(sections);
        this.sectionsWritable.set(sections);
    }
    quitSection(sectionId) {
        if (!this.hasSection(sectionId)) {
            return;
        }
        const sections = this.sections.filter(({ id }) => id !== sectionId);
        this.updateSectionsPositions(sections);
        this.sectionsWritable.set(sections);
    }
    moveSectionUp(section) {
        if (!this.hasSection(section.id)) {
            return;
        }
        const { sections } = this;
        const index = sections.findIndex(({ id }) => id === section.id);
        if (index === 0) {
            return;
        }
        sections.splice(index, 1);
        sections.splice(index - 1, 0, section);
        this.updateSectionsPositions(sections);
        this.sectionsWritable.set(sections);
    }
    moveSectionDown(section) {
        if (!this.hasSection(section.id)) {
            return;
        }
        const { sections } = this;
        const index = sections.findIndex(({ id }) => id === section.id);
        if (index === sections.length - 1) {
            return;
        }
        sections.splice(index, 1);
        sections.splice(index + 1, 0, section);
        this.updateSectionsPositions(sections);
        this.sectionsWritable.set(sections);
    }
    remove() {
        this.section.quitQuestion(this.id);
    }
    toJSON() {
        const options = Object.assign({}, this.options);
        if (options.questionOptions)
            options.questionOptions = options.questionOptions.toJSON();
        return {
            formId: this.form.id,
            sectionId: this.section.id,
            id: this.id,
            name: this.name.value,
            description: this.description.value,
            status: this.status.value,
            useAnswerInFileName: this.useAnswerInFileName.value,
            position: this.position.value,
            width: this.width.value,
            type: this.type,
            forced: this.forced.value,
            date_created: this.date_created.value,
            date_updated: this.date_updated.value,
            date_disabled: this.date_disabled.value,
            sections: this.sections,
            options,
        };
    }
    hasSection(sectionId) {
        return this.sections.some(({ id }) => id === sectionId);
    }
    updateSectionsPositions(sections) {
        sections.forEach((section, index) => {
            section.position.set(index);
        });
    }
}
